module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "noMargin"
  }, [(_vm.objAuthorize.privileges.indexOf('TRANSPORT_MODULE') !== -1) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "pageTitle"
  }, [_c('h2', [_vm._v("COST MATRIX")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque a nulla mauris. Vestibulum augue enim, aliquam eget mi sit amet, mattis tempus risus. Vivamus blandit pretium lorem eu placerat. Aenean tincidunt lobortis massa, non viverra nibh volutpat ac. Maecenas sed bibendum neque. Cras et nisl tortor.")])]), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-5",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncRadiusStructure.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")]), _vm._v("Edit Radius Structure")]), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-5",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncAddMatrix.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")]), _vm._v("Add")]), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-5",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncSaveMatrix.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")]), _vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-5",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncReloadMatrix.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("refresh")]), _vm._v("Reload")])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}